/* Ken the Cat — theme JS
   Small, dependency-free. Menu, search, quantity steppers, AJAX cart,
   variant picking, toasts. Ken did the bare minimum. */
(function () {
  'use strict';

  var money = function (cents) {
    var symbol = (window.KenTheme && window.KenTheme.moneySymbol) || '£';
    return symbol + (cents / 100).toFixed(2);
  };

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function toast(msg) {
    var el = document.getElementById('ktc-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ktc-toast';
      el.className = 'ktc-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
    el.style.animation = 'none';
    void el.offsetWidth; /* restart animation */
    el.style.animation = '';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.style.display = 'none'; }, 2600);
  }
  window.KenToast = toast;

  /* ---------- Header: hide on scroll down, reveal on scroll up ---------- */
  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var lastY = window.pageYOffset || 0;
    var lastRun = 0;
    function onScroll() {
      var y = window.pageYOffset || 0;
      var menu = document.getElementById('mobile-menu');
      var search = document.getElementById('header-search');
      var open = (menu && menu.classList.contains('is-open')) || (search && search.classList.contains('is-open'));
      header.classList.toggle('site-header--stuck', y > 4);
      if (open) { header.classList.remove('site-header--hidden'); lastY = y; return; }
      if (y > lastY && y > 140) { header.classList.add('site-header--hidden'); }
      else if (y < lastY - 4) { header.classList.remove('site-header--hidden'); }
      lastY = y;
    }
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - lastRun < 60) return;
      lastRun = now;
      onScroll();
    }, { passive: true });
  })();

  /* ---------- Wishlist (localStorage + drawer) ---------- */
  var WISH_KEY = 'ktc_wishlist';
  function getWish() {
    try {
      var raw = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      return raw.filter(function (x) { return x && typeof x === 'object' && x.id; });
    } catch (e) { return []; }
  }
  function setWish(a) { try { localStorage.setItem(WISH_KEY, JSON.stringify(a)); } catch (e) {} }
  function wishIndex(list, id) { for (var i = 0; i < list.length; i++) { if (String(list[i].id) === String(id)) return i; } return -1; }

  function markWish() {
    var w = getWish();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      var on = wishIndex(w, b.getAttribute('data-wishlist-id')) >= 0;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('[data-wishlist-label]');
      if (label) label.textContent = on ? (b.getAttribute('data-on-label') || 'Saved to wishlist') : (b.getAttribute('data-off-label') || 'Add to wishlist');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = w.length > 0 ? w.length : '';
    });
    if (document.getElementById('wishlist-drawer') && !document.getElementById('wishlist-drawer').hidden) renderWishlist();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var id = b.getAttribute('data-wishlist-id');
    var w = getWish();
    var i = wishIndex(w, id);
    if (i >= 0) { w.splice(i, 1); toast('Off the wishlist. Ken knew you’d flake.'); }
    else {
      w.push({
        id: id,
        title: b.getAttribute('data-title') || 'Ken thing',
        url: b.getAttribute('data-url') || '#',
        image: b.getAttribute('data-image') || '',
        price: b.getAttribute('data-price') || '',
        variantId: b.getAttribute('data-variant-id') || '',
        available: b.getAttribute('data-available') === 'true'
      });
      toast('Saved. Ken is quietly judging your taste.');
    }
    setWish(w);
    markWish();
  });

  /* Drawer render + open/close */
  function renderWishlist() {
    var body = document.querySelector('[data-wishlist-body]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!body) return;
    var w = getWish();
    if (empty) empty.hidden = w.length > 0;
    body.innerHTML = w.map(function (it) {
      var addBtn = it.available && it.variantId
        ? '<button class="wl-row__add" data-wishlist-add="' + it.variantId + '">Add to basket</button>'
        : '<a class="wl-row__add" href="' + it.url + '">View</a>';
      return '<div class="wl-row" data-wishlist-row="' + it.id + '">' +
        '<a class="wl-row__media" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="wl-row__info">' +
          '<a class="wl-row__title" href="' + it.url + '">' + it.title + '</a>' +
          '<div class="wl-row__price">' + (it.price || '') + '</div>' +
          addBtn +
        '</div>' +
        '<button class="wl-row__remove" data-wishlist-remove="' + it.id + '" aria-label="Remove">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"></path></svg>' +
        '</button>' +
      '</div>';
    }).join('');
  }
  function openWishlist() {
    var d = document.getElementById('wishlist-drawer');
    if (!d) return;
    renderWishlist();
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    // fallback if rAF is throttled
    setTimeout(function () { d.classList.add('is-open'); }, 30);
    document.body.style.overflow = 'hidden';
  }
  function closeWishlist() {
    var d = document.getElementById('wishlist-drawer');
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, 260);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-open]')) { e.preventDefault(); openWishlist(); return; }
    if (e.target.closest('[data-wishlist-close]')) { e.preventDefault(); closeWishlist(); return; }
    var rem = e.target.closest('[data-wishlist-remove]');
    if (rem) {
      var w = getWish(); var i = wishIndex(w, rem.getAttribute('data-wishlist-remove'));
      if (i >= 0) { w.splice(i, 1); setWish(w); markWish(); }
      return;
    }
    var add = e.target.closest('[data-wishlist-add]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-wishlist-add');
      add.disabled = true; var t = add.textContent; add.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) { updateCartCount(cart.item_count); toast('In the basket. Ken remains unimpressed.'); add.textContent = 'Added ✓'; setTimeout(function () { add.disabled = false; add.textContent = t; }, 1400); })
        .catch(function () { toast('That didn’t work. Ken is not surprised.'); add.disabled = false; add.textContent = t; });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeWishlist(); });
  markWish();

  /* ---------- Header: mobile menu + search ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-menu-toggle]');
    if (burger) {
      var menu = document.getElementById('mobile-menu');
      if (menu) {
        var open = menu.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }
    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var bar = document.getElementById('header-search');
      if (bar) {
        var isOpen = bar.classList.toggle('is-open');
        searchToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (isOpen) {
          var input = bar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
    }
  });

  /* ---------- Quantity steppers (event delegation) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrap = btn.closest('.ktc-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var delta = parseInt(btn.getAttribute('data-qty-change'), 10);
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + delta);
    if (input.value !== String(next)) {
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* ---------- Cart helpers ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      var badge = el.closest('.ktc-iconbtn') || el;
      badge.classList.remove('is-pop');
      void el.offsetWidth;
      badge.classList.add('is-pop');
    });
  }

  function refreshCartSection() {
    var cartRoot = document.querySelector('[data-cart-section]');
    if (!cartRoot) return Promise.resolve(false);
    var sectionId = cartRoot.getAttribute('data-cart-section');
    return fetch(window.location.pathname + '?section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-section]');
        if (fresh) cartRoot.replaceWith(fresh);
        return true;
      });
  }

  /* ---------- Add to cart (product forms + quick add) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding-label') || 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.data.description || res.data.message || 'That didn’t work. Ken is not surprised.');
          if (btn) { btn.disabled = false; btn.textContent = original; }
          return null;
        }
        toast(form.getAttribute('data-added-message') || 'In the basket. Ken remains unimpressed.');
        if (btn) {
          btn.textContent = btn.getAttribute('data-added-label') || 'Added ✓';
          btn.classList.add('is-added');
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-added');
            btn.textContent = original;
          }, 1600);
        }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshCartSection();
        });
      })
      .catch(function () {
        toast('Something broke. Ken denies all knowledge.');
        if (btn) { btn.disabled = false; btn.textContent = original; }
      });
  });

  /* ---------- Cart page: line quantity change / remove ---------- */
  var cartUpdateTimer = null;
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    var line = input.getAttribute('data-line-qty');
    clearTimeout(cartUpdateTimer);
    cartUpdateTimer = setTimeout(function () { changeLine(line, parseInt(input.value, 10) || 0); }, 250);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove]');
    if (!btn) return;
    e.preventDefault();
    changeLine(btn.getAttribute('data-line-remove'), 0);
  });
  function changeLine(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshCartSection();
      })
      .catch(function () { toast('Couldn’t update. Try again.'); });
  }

  /* ---------- Product page: variant + live price + multi-buy ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var atc = root.querySelector('[data-atc]');
    var qtyInput = root.querySelector('.ktc-qty input');
    var savings = root.querySelector('[data-bulk-nudge]');
    var dataEl = root.querySelector('[data-variants-json]');
    var variants = null;
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) {} }

    var t1q = atc ? parseInt(atc.getAttribute('data-t1-qty'), 10) || 0 : 0;
    var t1p = atc ? parseInt(atc.getAttribute('data-t1-pct'), 10) || 0 : 0;
    var t2q = atc ? parseInt(atc.getAttribute('data-t2-qty'), 10) || 0 : 0;
    var t2p = atc ? parseInt(atc.getAttribute('data-t2-pct'), 10) || 0 : 0;

    function rate(q) { if (t2q && q >= t2q) return t2p / 100; if (t1q && q >= t1q) return t1p / 100; return 0; }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function unit() { return atc ? parseInt(atc.getAttribute('data-unit-price'), 10) || 0 : 0; }

    function updatePricing() {
      if (!atc || atc.disabled || atc.classList.contains('is-added')) return;
      var q = qty(), up = unit(), r = rate(q);
      var gross = up * q, net = Math.round(gross * (1 - r));
      var label = atc.getAttribute('data-add-label') || 'Add to basket';
      atc.textContent = label + ' · ' + money(net);
      if (savings) {
        if (r > 0) {
          var msg = 'You’re saving ' + Math.round(r * 100) + '% (' + money(gross - net) + ').';
          if (t2q && q < t2q) msg += ' Add ' + (t2q - q) + ' more, save ' + t2p + '%.';
          savings.innerHTML = '<strong>' + msg + '</strong>';
        } else if (t1q) {
          savings.textContent = 'Buy ' + t1q + ' save ' + t1p + '% · Buy ' + t2q + ' save ' + t2p + '%.';
        } else { savings.textContent = ''; }
      }
    }

    function currentOptions() {
      var opts = [];
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (val, i) { return val === opts[i]; }); });
    }
    function renderVariant(variant) {
      var idInput = root.querySelector('input[name="id"]');
      var priceNow = root.querySelector('[data-price]');
      var priceWas = root.querySelector('[data-compare-price]');
      if (!variant) { if (atc) { atc.disabled = true; atc.textContent = atc.getAttribute('data-unavailable-label') || 'Unavailable'; } return; }
      if (idInput) idInput.value = variant.id;
      if (atc) atc.setAttribute('data-unit-price', variant.price);
      if (priceNow) {
        priceNow.textContent = money(variant.price);
        priceNow.classList.toggle('ktc-price__now--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
      }
      if (priceWas) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) { priceWas.textContent = money(variant.compare_at_price); priceWas.hidden = false; }
        else { priceWas.hidden = true; }
      }
      if (atc) {
        if (variant.available) { atc.disabled = false; updatePricing(); }
        else { atc.disabled = true; atc.textContent = atc.getAttribute('data-soldout-label') || 'Sold out'; }
      }
      if (variant.featured_image && variant.featured_image.src) {
        var main = root.closest('.pdp') && root.closest('.pdp').querySelector('[data-main-image]');
        if (main) { main.removeAttribute('srcset'); main.src = variant.featured_image.src; }
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (variants) {
      root.addEventListener('change', function (e) {
        if (!e.target.closest('[data-option-index]')) return;
        renderVariant(findVariant(currentOptions()));
      });
    }
    if (qtyInput) { qtyInput.addEventListener('change', updatePricing); qtyInput.addEventListener('input', updatePricing); }
    updatePricing();
  });

  /* ---------- PDP gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb-src]');
    if (!thumb) return;
    var pdp = thumb.closest('.pdp');
    var main = pdp && pdp.querySelector('[data-main-image]');
    if (main) {
      var srcset = thumb.getAttribute('data-thumb-srcset');
      if (srcset) { main.srcset = srcset; } else { main.removeAttribute('srcset'); }
      main.src = thumb.getAttribute('data-thumb-src');
      pdp.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* leave empty */ });
  });

  /* ---------- Newsletter: success message via URL ---------- */
  if (/customer_posted=true/.test(window.location.search)) {
    var nl = document.querySelector('[data-newsletter]');
    if (nl) {
      var form = nl.querySelector('[data-newsletter-form]');
      var success = nl.querySelector('[data-newsletter-success]');
      if (form) form.hidden = true;
      if (success) success.hidden = false;
      nl.scrollIntoView({ block: 'center' });
    }
  }

  /* ---------- Newsletter pop-up ---------- */
  (function () {
    var pop = document.querySelector('[data-newsletter-popup]');
    if (!pop) return;

    var KEY = 'ktc_popup';
    var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
    var write = function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };
    var now = function () { return Date.now(); };

    var card = pop.querySelector('.ken-pop__card');
    var formView = pop.querySelector('[data-pop-form-view]');
    var successView = pop.querySelector('[data-pop-success-view]');
    var freqDays = parseInt(pop.getAttribute('data-frequency-days'), 10) || 14;
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 18) * 1000;
    var opened = false, lastFocus = null;

    function trapFocus(e) {
      if (e.key === 'Escape') { close('dismiss'); return; }
      if (e.key !== 'Tab') return;
      var f = card.querySelectorAll('button, [href], input, select, textarea');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open(showSuccess) {
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      if (showSuccess) {
        if (formView) formView.hidden = true;
        if (successView) successView.hidden = false;
      }
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', trapFocus);
      var focusMe = showSuccess ? card.querySelector('[data-pop-close]') : card.querySelector('input, button');
      if (focusMe) setTimeout(function () { focusMe.focus(); }, 40);
    }

    function close(reason) {
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', trapFocus);
      setTimeout(function () { pop.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      var state = read();
      if (reason !== 'subscribed') { state.snoozeUntil = now() + freqDays * 864e5; }
      write(state);
    }

    // Just subscribed: Shopify reloaded the page with the form success flag set.
    if (window.__kenPopJustSubscribed) {
      var s = read(); s.subscribed = true; write(s);
      open(true);
    } else {
      var state = read();
      var onCartLike = /^\/(cart|checkout)/.test(window.location.pathname) || document.body.classList.contains('template-cart');
      var suppressed = state.subscribed || (state.snoozeUntil && state.snoozeUntil > now()) || onCartLike;

      if (!suppressed) {
        var armed = true;
        var fire = function () { if (armed) { armed = false; cleanup(); open(false); } };
        var timer = setTimeout(fire, delay);
        var onScroll = function () {
          var sc = (window.pageYOffset || document.documentElement.scrollTop);
          var h = document.documentElement.scrollHeight - window.innerHeight;
          if (h > 0 && sc / h > 0.45) fire();
        };
        var onExit = function (e) { if (e.clientY <= 0) fire(); };
        var cleanup = function () {
          clearTimeout(timer);
          window.removeEventListener('scroll', onScroll);
          document.removeEventListener('mouseout', onExit);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        // Exit-intent is desktop only (no reliable mouseout-to-top on touch).
        if (!('ontouchstart' in window)) document.addEventListener('mouseout', onExit);
      }
    }

    pop.querySelectorAll('[data-pop-close]').forEach(function (b) {
      b.addEventListener('click', function () { close(read().subscribed ? 'subscribed' : 'dismiss'); });
    });
    pop.querySelectorAll('.ken-pop__overlay').forEach(function (o) {
      o.addEventListener('click', function () { close(read().subscribed ? 'subscribed' : 'dismiss'); });
    });

    var copyBtn = pop.querySelector('[data-pop-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = (pop.querySelector('[data-pop-code]') || {}).textContent || '';
        var done = function () {
          var was = copyBtn.textContent;
          copyBtn.textContent = copyBtn.getAttribute('data-copied-label') || 'Copied';
          setTimeout(function () { copyBtn.textContent = was; }, 1600);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code.trim()).then(done, done);
        else done();
      });
    }
  })();
})();
